export default "__VITE_ASSET__CkGops$K__"